<template>
  <tr>
    <component :is="isTotal ? 'th' : 'td'">
      {{ rule.type }}
    </component>
    <component :is="isTotal ? 'th' : 'td'">
      <div class="progress">
        <div
          role="progressbar"
          class="progress-bar progress-bar-success"
          :style="progressStyle()"
          :aria-valuemax="getMax"
        >
          {{ getPoints }}
        </div>
        <div
          role="progressbar"
          class="progress-bar progress-bar-danger"
          :style="progressStyleTodo()"
          :aria-valuemax="getMax"
        >
          {{ getTodoPoints }}
        </div>
        <div
          role="progressbar"
          class="progress-bar"
          :style="progressStyleAvailable()"
          :aria-valuemax="getMax"
        >
          {{ getAvailablePoints }}
        </div>
      </div>
    </component>
    <component :is="isTotal ? 'th' : 'td'">
      <span
        :class="achieved"
        class="achieved"
      />
    </component>
  </tr>
</template>

<script>
export default {
  name: 'ColloquiumRule',
  props: {
    rule: { required: true },
    isTotal: { required: false, default: false },
  },

  computed: {
    getMax () {
      return this.rule.max === 0 ? this.rule.min : this.rule.max
    },
    achieved () {
      if (this.rule.student_points >= this.rule.min) {
        return 'fa fa-check'
      }
      return 'fa fa-remove'
    },

    // This is how many points the student can maximally get for the global goal.
    getAvailablePoints () {
      // If the student has more points than the maximum then there are 0 point more available for
      // the total goal
      if (this.rule.student_points > this.rule.max) {
        return 0
      }
      // If the student has more then min there are between the current points and the max left fot
      // the total goal
      else if (this.rule.student_points > this.rule.min) {
        return this.rule.max - this.rule.student_points
      }
      // Else there are between min and max left (the rest is needed for the student to achieve the
      // subgoal.
      else {
        return this.rule.max - this.rule.min
      }
    },

    // This is the points for the total goal the student has
    getPoints () {
      if (this.rule.max != 0) {
        return Math.min(this.rule.max, this.rule.student_points)
      }
      return this.rule.student_points
    },

    // This is the number of points the student needs to do to pass the min rule.
    getTodoPoints () {
      return this.rule.min - this.rule.student_points < 0 ? 0 : this.rule.min - this.rule.student_points
    },
  },
  methods: {

    getWidth (points) {
      // make sure we never divide by zero (in case min and max are zero
      return Math.min(100, Math.round(100 * points / (this.getMax === 0 ? 1000 : this.getMax)))
    },

    progressStyle () {
      // in case we have no max for this category (e.g. we can have any number of points that will count
      // make sure the max is 100
      let width = this.getMax === 0 && this.rule.student_points > 0 ? 100 : this.getWidth(this.rule.student_points)
      return `width: ${width}%`
    },
    progressStyleTodo () {
      // make sure we display rounded summed values over 100% properly
      let width = this.getWidth(this.getTodoPoints)
      let sWidth = this.getWidth(this.rule.student_points)
      if (width + sWidth > 100) {
        width = 100 - sWidth
      }
      return `width: ${width}%`
    },

    progressStyleAvailable () {
      let width
      if (this.getMax === 0 && this.rule.student_points > 0) {
        // in case we have no max (e.g. we can have any number of points that will count and we have any points,
        // do not show the available
        width = 0
      } else {
        // make sure we display rounded summed values over 100% properly
        width = this.getWidth(this.getAvailablePoints)
        let otherWidth = this.getWidth(this.getTodoPoints) + this.getWidth(this.rule.student_points)
        width = 100 - otherWidth
      }
      return `width: ${width}%; background-color:#ccc`
    },

  },
}
</script>

<style scoped>
    .achieved {
        text-align: center

    }
</style>
